import type { UTXO } from '../../WaasBitcoinWalletProvider.types';

type SelectUTXOsLargestFirstOptions = {
  targetAmount: number;
  utxos: UTXO[];
};

/**
 * Selects UTXOs using Largest-First (Accumulator) strategy
 * Sorts UTXOs by value (descending) and selects until we have enough to cover amount + fees
 *
 * @param options.targetAmount - Target amount in satoshis (amount + fees + dust limit)
 * @param options.utxos - Array of available UTXOs to select from
 * @returns Selected UTXOs
 */
export const selectUTXOsLargestFirst = (
  options: SelectUTXOsLargestFirstOptions
) => {
  const { targetAmount, utxos } = options;

  const sortedUTXOs = [...utxos].sort((a, b) => b.value - a.value);

  const selected: UTXO[] = [];
  let total = 0;

  for (const utxo of sortedUTXOs) {
    selected.push(utxo);
    total += utxo.value;

    if (total >= targetAmount) {
      break;
    }
  }

  return selected;
};
